import { j as s } from '../../../_virtual/jsx-runtime.js';
const x = ({ clientIcon: e, clientUrl: r, dandgLogo: o, clientName: l }) => {
  const a = 'flex items-center px-5 md:px-16 lg:px-24';
  return /* @__PURE__ */ s.jsxs('header', {
    children: [
      /* @__PURE__ */ s.jsx('div', {
        className: `${a} py-4`,
        children:
          e &&
          /* @__PURE__ */ s.jsx('a', {
            href: r,
            className: 'justify-start',
            children: /* @__PURE__ */ s.jsx('img', {
              src: e,
              className: 'max-h-22 ml-0 lg:ml-14',
              alt: `${l} Logo`,
            }),
          }),
      }),
      /* @__PURE__ */ s.jsx('div', {
        className: `bg-neutral-50 py-2 justify-end ${a}`,
        children: /* @__PURE__ */ s.jsx('img', {
          src: o,
          alt: 'D&G Logo',
          className: ' max-h-8 mr-0 lg:mr-14',
        }),
      }),
    ],
  });
};
export { x as HeaderCobranded };
